export default {
    meta: {
        title: '沟通列表',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务'
    }
};
